import { burstConfetti } from './ctaConfetti.js';

let itemId = 0;

export function vacancyChecklist(root = document) {
    root.querySelectorAll('ul.vacancy-checklist').forEach((list) => {
        if (list.hasAttribute('data-vacancy-checklist-init')) return;

        const items = Array.from(list.children).filter((item) => item.tagName === 'LI');
        if (!items.length) return;

        list.setAttribute('data-vacancy-checklist-init', '');
        list.setAttribute('role', 'list');

        let celebrated = false;
        const checkboxes = items.map((item) => {
            const content = document.createElement('div');
            content.className = 'vacancy-checklist__text';
            do {
                itemId += 1;
                content.id = `vacancy-checklist-item-${itemId}`;
            } while (document.getElementById(content.id));
            content.append(...item.childNodes);

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.className = 'vacancy-checklist__checkbox';
            checkbox.setAttribute('aria-labelledby', content.id);
            item.append(checkbox, content);
            item.classList.remove('is-checked');

            // Preserve links and other interactive WYSIWYG content inside the row.
            item.addEventListener('click', (event) => {
                if (event.target.closest('li') !== item) return;
                if (event.target.closest('a, button, input, select, textarea, label, [contenteditable]')) return;
                checkbox.focus({ preventScroll: true });
                checkbox.click();
            });

            checkbox.addEventListener('change', () => {
                item.classList.toggle('is-checked', checkbox.checked);
                const complete = checkboxes.every((input) => input.checked);

                if (complete && !celebrated) {
                    celebrated = true;
                    burstConfetti(checkbox);
                }
            });

            return checkbox;
        });
    });
}
